function requestIdleCallback(callback, options) {
  if (typeof window !== "undefined") {
    if ("requestIdleCallback" in window) {
      return window.requestIdleCallback(callback, options);
    } else {
      return _requestIdleCallback(callback);
    }
  } else {
    return _requestIdleCallback(callback);
  }
}
function cancelIdleCallback(id) {
  if (typeof window !== "undefined") {
    if ("cancelIdleCallback" in window) {
      window.cancelIdleCallback(id);
    } else {
      _cancelIdleCallback(id);
    }
  }
}
function _requestIdleCallback(cb) {
  const start = Date.now();
  return window.setTimeout(function() {
    cb({
      didTimeout: false,
      timeRemaining: function() {
        return Math.max(0, 50 - (Date.now() - start));
      }
    });
  }, 1);
}
function _cancelIdleCallback(id) {
  clearTimeout(id);
}
function scheduleTaskInIdleTime(cb, timeout, minTimeForProcessing = 0) {
  const deadline = Date.now() + timeout;
  const schedule = (timeout2) => requestIdleCallback((idleData) => {
    const now = Date.now();
    if (now >= deadline || idleData.timeRemaining() > minTimeForProcessing)
      return cb();
    schedule(deadline - now);
  }, { timeout: timeout2 });
  schedule(timeout);
}

export { cancelIdleCallback, requestIdleCallback, scheduleTaskInIdleTime };
